<template>
    <span :class="cssClasses">{{beginDate | formatDate}} - {{endDate | formatDate}}</span>
</template>

<script>
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import {mapGetters} from "vuex";

    export default {
        name: "DisplayDate",
        computed: {
            ...mapGetters(SEARCH_NS, [
                'beginDate',
                'endDate',
                'ignoreDate'
            ]),
            cssClasses() {
                return {
                    'disabled': this.ignoreDate,
                    'grey--text': this.ignoreDate
                }
            }
        }
    }
</script>

<style scoped>
    .disabled {
        text-decoration: line-through;
    }
</style>